import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { Icon, NakedButton } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

const favouriteAnimation = keyframes`
  0% {
    transform: scale(0.5);
  }
  70% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

const nonFavouriteAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
`;

export const FavouriteIcon = styled(Icon)`
  color: ${themeGet('colors.brand.primary')};
  transform-origin: center center;
  animation: ${favouriteAnimation} 0.25s ease-in-out;
`;

export const NonFavouriteIcon = styled(Icon)`
  color: ${themeGet('colors.greys.charcoal')};
  transform-origin: center center;
  animation: ${nonFavouriteAnimation} 0.25s ease-in-out;
`;

export const FavouriteButton = styled(NakedButton)`
  background-color: ${themeGet('colors.snow')};
  border-radius: ${themeGet('radii.rounded')};
  box-shadow: ${themeGet('shadows.hard')};
  display: block;
  padding: ${themeGet('space.3')};
  transition: box-shadow 0.2s;

  &:focus {
    outline: none;
    box-shadow: ${themeGet('focus.boxShadow')};
  }

  &:hover {
    box-shadow: ${themeGet('shadows.hover')};
  }
`;
